import { useTranslation } from "@/lib/i18n";

const retailers = [
  {
    name: "Canadian Tire",
    logo: "https://cdn.brandfetch.io/idhj_i33-X/w/800/h/706/theme/dark/logo.png?c=1bxid64Mup7aczewSAYMX&t=1667562145361",
  },
  {
    name: "RONA",
    logo: "https://cdn.brandfetch.io/idUhsg2SPn/w/820/h/170/theme/dark/logo.png",
  },
  {
    name: "Home Depot",
    logo: "https://cdn.worldvectorlogo.com/logos/the-home-depot-2.svg",
  },
  {
    name: "Walmart",
    logo: "https://static.cdnlogo.com/logos/w/32/walmart.svg",
    scale: 2,
  },
  {
    name: "IKEA",
    logo: "https://cdn.worldvectorlogo.com/logos/ikea-1.svg",
    scale: 2,
  },
  {
    name: "Best Buy",
    logo: "https://logos-world.net/wp-content/uploads/2020/11/Best-Buy-Logo.png",
  },
  {
    name: "Jean Coutu",
    logo: "/logos/jean-coutu.jpg",
    scale: 2,
  },
  {
    name: "Stokes",
    logo: "/logos/stokes.png",
    scale: 2,
  },
  {
    name: "Michaels",
    logo: "/logos/michaels.png",
  },
  {
    name: "Sports Experts",
    logo: "/logos/sports-experts.png",
  },
  {
    name: "Costco",
    logo: "/logos/costco.svg",
  },
  {
    name: "Dollarama",
    logo: "/logos/dollarama.png",
  },
  {
    name: "Tigre Géant",
    logo: "/logos/giant-tiger.svg",
  },
  {
    name: "BMR",
    logo: "/logos/bmr.png",
  },
  {
    name: "Canac",
    logo: "/logos/canac.png",
  },
  {
    name: "Décathlon",
    logo: "/logos/decathlon.svg",
  },
  {
    name: "Reitmans",
    logo: "/logos/reitmans.svg",
  },
  {
    name: "Renaud-Bray",
    logo: "/logos/renaud-bray.png",
  },
  {
    name: "Archambault",
    logo: "/logos/archambault.png",
    scale: 1.8,
  },
  {
    name: "Home Hardware",
    logo: "/logos/home-hardware.svg",
    scale: 1.8,
  },
  {
    name: "Réno-Dépôt",
    logo: "/logos/reno-depot.svg",
  },
  {
    name: "Maxi",
    logo: "/logos/maxi.svg",
  },
  {
    name: "Provigo",
    logo: "/logos/provigo.svg",
  },
  {
    name: "Loblaws",
    logo: "/logos/loblaws.svg",
  },
  {
    name: "Bureau en Gros",
    logo: "/logos/bureau-en-gros.svg",
  },
  {
    name: "Pharmaprix",
    logo: "/logos/pharmaprix.svg",
  },
];

function RetailerCard({ retailer }: { retailer: { name: string; logo: string; scale?: number } }) {
  return (
    <div className="flex-shrink-0 flex items-center justify-center bg-white border border-border rounded-xl p-5 sm:p-6 w-[160px] sm:w-[180px] h-[80px] sm:h-[90px] mx-3">
      <img
        src={retailer.logo}
        alt={`${retailer.name} logo`}
        className="w-[80%] h-[70%] object-contain"
        style={retailer.scale ? { transform: `scale(${retailer.scale})` } : undefined}
      />
    </div>
  );
}

export function Retailers() {
  const { t } = useTranslation();
  const doubled = [...retailers, ...retailers];
  // Keep the scroll speed constant as the retailer list grows (base: 30s for 16 logos)
  const marqueeDuration = `${Math.round((retailers.length / 16) * 30)}s`;

  return (
    <section id="retailers" className="py-20 sm:py-28 bg-secondary/30 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14 animate-fade-up">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {t("retailers.retailersTitle")}
          </h2>
          <p className="text-lg text-muted-foreground">
            {t("retailers.retailersDesc")}
          </p>
        </div>
      </div>

      <div className="relative">
        {/* Left fade mask */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 sm:w-40 z-10 bg-gradient-to-r from-background to-transparent" />
        {/* Right fade mask */}
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 sm:w-40 z-10 bg-gradient-to-l from-background to-transparent" />

        <div className="flex flex-col gap-4 overflow-hidden">
          {/* Row 1 - normal direction */}
          <div className="marquee-track" style={{ animationDuration: marqueeDuration }}>
            {doubled.map((retailer, i) => (
              <RetailerCard key={`row1-${retailer.name}-${i}`} retailer={retailer} />
            ))}
          </div>

          {/* Row 2 - reverse direction */}
          <div
            className="marquee-track"
            style={{ animationDirection: "reverse", animationDuration: marqueeDuration }}
          >
            {doubled.map((retailer, i) => (
              <RetailerCard key={`row2-${retailer.name}-${i}`} retailer={retailer} />
            ))}
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <p className="text-center text-sm text-muted-foreground">
          {t("retailers.retailersDisclaimer")}
        </p>
      </div>
    </section>
  );
}
